import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { getAccessToken } from '@/api';

interface RequireAuthProps {
  children: React.ReactNode;
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const { authenticated, refreshProfile } = useAuthStore();
  const hasToken = !!getAccessToken();

  useEffect(() => {
    if (hasToken && !authenticated) {
      refreshProfile().catch(() => {
        /* 拦截器已统一提示并跳转 login */
      });
    }
  }, [hasToken, authenticated, refreshProfile]);

  if (!hasToken && !authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
